import { say } from "../../words.ts";

/**
 * Every word the emote wheel shows or says that is not the emote table's (P2.19-T8; ADR-114 decision 1.4: "`words.ts`
 * holds every word as a draft"). The author accepted these, and the action's name "Emotes", on 2026-10-08 ("Accept all
 * (Recommended)", ADR-114's note of that day), and chose `typing`'s "Typing" the same day ("Typing (Recommended)", the
 * note's item 11): none is a draft. The pages' names, the words on the entries and the sentences an action sends are
 * the emote table's (`odyssey-shared/src/emotes/table.ts`), which the map server reads too. A refusal's sentence is the
 * chat panel's (`chat/words.ts`: `emote`, `target`, `rate`), since a refused emote is answered as a line of chat. The
 * action's name in Settings, Controls is `controls/actions.ts`'s, which the game menu's item reads. The legends on the
 * wheel's key glyphs are its keys' labels (`keys.ts` `emoteKeyLabels`).
 */
export const EMOTE_WORDING = {
  /** The wheel's accessible name; "emote wheel" is the author's word for it. */
  wheel: say("wheel.wheel"),
  /** The accessible name of the control that turns to the page before. */
  pageBefore: say("wheel.pageBefore"),
  /** The accessible name of the control that turns to the page after. */
  pageAfter: say("wheel.pageAfter"),
  /** The button that sends the selection. */
  send: say("wheel.send"),
  /** The button that closes the wheel. */
  close: say("wheel.close"),
  /** The plaque's line while a text field owns the keyboard, the author's choice (P2.19-T11). */
  typing: say("wheel.typing"),
} as const;
